import React, { useContext } from 'react';
import { Field } from 'react-final-form';
import { Column, LocaleContext, Row } from 'shared';
import { required as requiredValidator } from 'utils/formValidators';

import { AddNewLockFormLabel } from '../../AddNewLockForm.styles';

import { Period } from './period/Period';

export const PeriodPicker = () => {
  const localeContext = useContext(LocaleContext);

  const required = requiredValidator(localeContext.formatMessage({ id: 'FORM.REQUIRED' }));

  return (
    <Row>
      <Column size={[12]}>
        <AddNewLockFormLabel>
          {localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.CHOOSE_TIME_RANGE' })}
        </AddNewLockFormLabel>
      </Column>
      <Column size={[12]}>
        <Field name="period" validate={required}>
          {({ input, meta }) => <Period input={input} meta={meta} />}
        </Field>
      </Column>
    </Row>
  );
};
